/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { PropsWithChildren, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuthContext } from './AuthProvider'
import { stringify } from 'qs'

export type RequireAuthProps = PropsWithChildren & {
  fallback?: ReactNode,
  permissions: string[]
}

/**
 * Redirects user to sign-in page if not authenticated, or if missing
 * permissions.
 */
function RequireAuth (props: RequireAuthProps) {
  const {
    children,
    fallback,
    permissions
  } = props

  const {
    hasPermission,
    ready,
    signInUrl,
    signedIn,
    signingIn,
    signingOut
  } = useAuthContext()

  const location = useLocation()

  if (!ready) {
    return fallback
  }

  // Check if user is authenticated or if he has permissions to access component.
  if ((!signedIn || (permissions.length > 0 && !hasPermission(...permissions))) &&
    signInUrl && (ready && !signingIn && !signingOut)) {
    const params = { redirect: location.pathname + location.search }
    return <Navigate to={`${signInUrl}?${stringify(params)}`} />
  }
  return <>{children}</>
}

export default RequireAuth
